import React from "react";
import { BRAND } from "../lib/brand";

export default function WelcomeBanner() {
  return (
    <section
      id="welcome"
      data-testid="welcome-banner"
      className="relative overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #1F5A3E 0%, #2C7A57 55%, #1F5A3E 100%)",
      }}
    >
      {/* subtle texture */}
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(-45deg, rgba(255,255,255,0.7) 0 1px, transparent 1px 22px)",
        }}
      />
      <div className="absolute -left-32 -top-32 w-[520px] h-[520px] rounded-full bg-white/5 blur-3xl pointer-events-none" />
      <div className="absolute -right-24 -bottom-24 w-[420px] h-[420px] rounded-full bg-[color:var(--dbe-gold)]/10 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 py-12 sm:py-16 md:py-20 grid md:grid-cols-12 gap-6 sm:gap-8 md:gap-10 items-center">
        {/* Badge */}
        <div className="md:col-span-3 flex md:justify-start justify-center">
          <img
            src={BRAND.badge65}
            alt="Over 65 Years of Service"
            data-testid="welcome-65-badge"
            className="w-32 sm:w-40 md:w-48 drop-shadow-[0_20px_35px_rgba(0,0,0,0.35)]"
          />
        </div>

        {/* Copy */}
        <div className="md:col-span-6 text-white text-center md:text-left">
          <h2 className="font-bebas text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-wide leading-tight">
            Welcome to <span className="text-[color:var(--dbe-gold)]">Dead Bug Edwards</span>
          </h2>
          <p className="mt-4 md:mt-5 text-sm sm:text-base md:text-lg text-white/90 leading-relaxed max-w-2xl mx-auto md:mx-0">
            Your premier one-stop-shop for all of your termite and pest control needs,
            Since {BRAND.since}! Conveniently located at {BRAND.address.line1} in {BRAND.address.city}, {BRAND.address.state}.
            When Bob Edwards started out over 65 years ago, he gave his customers the kind of
            service that they would tell their friends and family about. We continue to put you first.
            You make our success possible at Dead Bug Edwards. We are never too busy to take the time
            to tell you <em className="not-italic font-semibold text-[color:var(--dbe-gold)]">Thank You for Your Business</em>.
            We look forward to providing you top-quality service with integrity and satisfaction.
          </p>

          <div className="mt-6 flex flex-col sm:flex-row gap-3 md:justify-start justify-center">
            <a
              href="#quote"
              data-testid="welcome-cta-quote"
              className="inline-flex items-center justify-center gap-2 bg-[color:var(--dbe-red)] hover:bg-[color:var(--dbe-red-deep)] text-white px-6 py-3 rounded-full font-bold uppercase tracking-wider text-xs sm:text-sm shadow-[0_15px_35px_-15px_rgba(0,0,0,0.4)]"
            >
              Get My Estimate <i className="fa-solid fa-arrow-right text-xs" />
            </a>
            <a
              href={`tel:${BRAND.phoneTel}`}
              data-testid="welcome-cta-call"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/40 text-white px-6 py-3 rounded-full font-bebas text-xl sm:text-2xl tracking-wide backdrop-blur-sm"
            >
              <i className="fa-solid fa-phone" /> {BRAND.phoneDisplay}
            </a>
          </div>
        </div>

        {/* Portrait */}
        <div className="md:col-span-3 flex md:justify-end justify-center">
          <div className="flex flex-col items-center md:items-end">
            <div className="relative">
              <div className="absolute inset-0 rounded-full bg-[color:var(--dbe-gold)]/40 blur-2xl scale-110" />
              <img
                src={BRAND.ownerPortrait}
                alt="Bruce Edwards - Dead Bug Edwards"
                data-testid="welcome-portrait"
                className="relative w-32 h-32 sm:w-40 sm:h-40 md:w-52 md:h-52 rounded-full object-cover ring-4 ring-white/90 shadow-[0_25px_50px_-15px_rgba(0,0,0,0.5)]"
                style={{ objectPosition: "center 25%" }}
              />
            </div>
            <div className="mt-4 text-center md:text-right">
              <div className="font-bebas text-2xl md:text-3xl text-[color:var(--dbe-gold)] tracking-wide leading-none">
                Bruce Edwards
              </div>
              <div className="mt-1 text-[10px] md:text-xs uppercase tracking-[0.25em] text-white/80">
                Owner
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
